<template>
    <Dropdown v-model="lang" :data="languages" lang-picker />
</template>

<script>
import Dropdown from '@/components/core/Dropdown.vue'
export default {
    name: 'LanguagePicker',
    components: {
      Dropdown
    },
    data () {
        return {
            lang: this.$i18n.locale,
            languages: {
                'nb': this.$t('lang.nb'), // 'nb-NO'
                'sv': this.$t('lang.sv'), // 'sv-SE'
                'fi': this.$t('lang.fi') // 'fi-FI'
            }
        }
    },
    watch: {
        lang: {
            handler(lang) {
                if(lang && lang !== this.$i18n.locale){
                    this.$i18n.locale = lang
                }
            },
            immediate: true
        }
    }
}
</script>